import { render } from "./PaymentMethod.vue?vue&type=template&id=b9424620&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"

import "./PaymentMethod.vue?vue&type=style&index=0&id=b9424620&lang=scss&scoped=true"

import exportComponent from "/home/www/omniauto/omniadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9424620"]])

export default __exports__